// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"480":"4ebe3830","972":"255caee2"}[chunkId] + ".js";
};